import { useTranslation } from '@thoughtspot/i18n';
import {
    Alert,
    BannerAlertType,
} from '@thoughtspot/radiant-react/widgets/alert';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import React from 'react';
import { Vertical } from '/@utils/layouts';
import { ShareObjectsContainerProps } from '../invite-users-v2.interface';
import { ShareObjects } from './share-objects';
import styles from './share-objects.module.scss';

export const ShareObjectsContainer: React.FC<ShareObjectsContainerProps> = ({
    isShareModalOpen,
    onConfirm,
    onDismiss,
    objectList,
    selectedSharableIds,
    setSelectedSharableIds,
    onDataSourceClicked,
    isLoading,
    errorMsg,
    isAlertBannerVisible,
    setIsAlertBannerVisible,
}) => {
    const { t } = useTranslation();
    return (
        <Modal
            isOpen={isShareModalOpen}
            size={ModalSize.MEDIUM3}
            title={t('invite.share.modal.header')}
            confirmButton={{
                text: t('invite.modal.next.send'),
                onConfirm,
            }}
            dismissButton={{
                text: t('Cancel'),
            }}
            onDismiss={onDismiss}
            isContentLoading={isLoading}
            customFooterClassName={styles.customFooter}
            customHeaderClassName={styles.customHeader}
        >
            <Vertical grow shrink className={styles.shareObjectsContainer}>
                <Alert.Banner
                    isVisible={isAlertBannerVisible}
                    message={errorMsg}
                    type={BannerAlertType.ERROR}
                    onClose={() => setIsAlertBannerVisible()}
                    className={styles.alertBanner}
                />
                <ShareObjects
                    objectList={objectList}
                    setSelectedSharableIds={setSelectedSharableIds}
                    selectedSharableIds={selectedSharableIds}
                    onDataSourceClicked={onDataSourceClicked}
                />
            </Vertical>
        </Modal>
    );
};
